import { createSlice } from '@reduxjs/toolkit';
import { ELEMENT_ACTION } from '../../actions/actionTypes';
import { isBackEvent } from './isBackEvent';

export const silentModeSlice = createSlice({
	name: 'emoji module silent mode',
	initialState: true,
	reducers: {
		toggle(state) {
			return !state;
		},
		setSilent(state, action) {
			return action.payload;
		},
		on() {
			return true;
		},
		off() {
			return false;
		},
	},
	extraReducers: {
		[ELEMENT_ACTION]: handleBackAction,
	},
});

/**
 * Should switch emoji in silent mode on "Back" action
 * @param state
 * @param {{type: string, payload: {event_type: string, event_code: string}}} action
 */
function handleBackAction(state, action) {
	const {
		payload,
	} = action;

	if (isBackEvent(payload)) {
		return true;
	}

	return state;
}

